import { useShortcutItemsConfig } from '../AppShortcuts/hooks/useShortcutItemsConfig.tsx';
import { useTeamsAppShortcut } from '../AppShortcuts/hooks/useTeamsAppShortcut.tsx';

export const useGlobalAppShortcuts = () => {
	const { config: teamsShortcutConfig, component: createTeamModalComponent } =
		useTeamsAppShortcut();
	const shortcuts = useShortcutItemsConfig({ teamsShortcutConfig });
	return { shortcuts, createTeamModalComponent };
};
